import { useCallback, useState } from 'react'
import { InvoiceSummaryWithCustomerJobData } from '../../../domain/invoicing/invoice'
import { StatementSummary } from '../../../domain/invoicing/statement'
import * as bulkSelection from './bulkSelectionModel'
import * as statementSelectionModel from './statementSelectionModel'
import * as invoiceSelectionModel from './invoiceSelectionModel'

export const useInvoiceSelection = () => {
  const [selection, setSelection] = useState<bulkSelection.BulkSelection>(bulkSelection.emptySelection())
  const [statementSelection, setStatementSelection] = useState<statementSelectionModel.StatementSelection>(statementSelectionModel.emptyStatementSelection())

  const clear = useCallback(() => {
    setSelection(bulkSelection.emptySelection())
    setStatementSelection(statementSelectionModel.emptyStatementSelection())
  }, [])

  return {
    clear,
    count: bulkSelection.selectedCount(selection) + statementSelectionModel.selectedStatementCount(statementSelection),
    totalCents: (totalInvoicedCents: number) =>
      invoiceSelectionModel.combinedSelectedTotalCents(selection, statementSelection, totalInvoicedCents),
    alreadySentCount: (sentCount: number) => bulkSelection.selectedAlreadySentCount(selection, sentCount),
    anyExported: (loadedSummaries: InvoiceSummaryWithCustomerJobData[], loadedStatements: StatementSummary[]) =>
      bulkSelection.isAnyExportedInSelection(selection, loadedSummaries)
      || statementSelectionModel.isAnyStatementExported(statementSelection, loadedStatements),
    isRowSelected: (invoiceId: string) => bulkSelection.isRowSelected(selection, invoiceId),
    toggleRow: (summary: InvoiceSummaryWithCustomerJobData) => setSelection(current => bulkSelection.toggleRow(current, summary)),
    isStatementSelected: (statementId: string) => statementSelectionModel.isStatementSelected(statementSelection, statementId),
    toggleStatement: (statement: StatementSummary) => setStatementSelection(current => statementSelectionModel.toggleStatement(current, statement)),
    selectAll: ({ invoiceIds, statementIds }: { invoiceIds: string[]; statementIds: string[] }) => {
      setSelection(bulkSelection.selectAll(invoiceIds))
      setStatementSelection(statementSelectionModel.selectAllStatements(statementIds))
    },
    toBulkRequest: () => ({
      invoiceIds: bulkSelection.selectedInvoiceIds(selection),
      statementIds: statementSelectionModel.selectedStatementIds(statementSelection),
    }),
  }
}
